import type { Root } from "mdast";

export const MERRY_MARKDOWN_PARSER_VERSION = "merry-markdown.v1";
export const MERRY_MARKDOWN_MAX_SOURCE_BYTES = 256 * 1024;
export const MERRY_MARKDOWN_MAX_AST_NODES = 10_000;

export type MerryMarkdownFallbackReason =
  | "ast_node_limit"
  | "parse_error"
  | "source_size_limit";

export interface MerryMarkdownProjectionLeaf {
  endOffsetUtf16: number;
  id: string;
  startOffsetUtf16: number;
  text: string;
}

export interface MerryMarkdownProjection {
  leaves: ReadonlyArray<MerryMarkdownProjectionLeaf>;
  schema: "conversation_selectable_text.v1";
  text: string;
}

export interface MerryMarkdownDocument {
  fallbackReason: MerryMarkdownFallbackReason | null;
  parserVersion: typeof MERRY_MARKDOWN_PARSER_VERSION;
  pending: boolean;
  projection: MerryMarkdownProjection;
  root: Root;
  source: string;
}

export interface MerryMarkdownAction {
  id: string;
  label: string;
}
